import { useState, useEffect, useCallback } from 'react';
import { getRoadblocks } from '../roadblockService';
import { listDFNs } from '../../../DFN/dfnService';

export function useRoadblockDashboard() {
    const [roadblocks, setRoadblocks] = useState([]);
    const [dfnOptions, setDfnOptions] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [resolvingId, setResolvingId] = useState(null);
    const [showExportModal, setShowExportModal] = useState(false);

    const fetchRoadblocks = useCallback(async () => {
        setLoaded(false);
        setError('');
        try {
            const data = await getRoadblocks({ status: 'open' });
            setRoadblocks(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => {
        fetchRoadblocks();
    }, [fetchRoadblocks]);

    useEffect(() => {
        listDFNs()
            .then(async resp => {
                if (resp.ok) {
                    const dfns = await resp.json();
                    setDfnOptions(dfns.map(d => ({ value: d.id, text: d.name })));
                }
            })
            .catch(() => {});
    }, []);

    return {
        loaded,
        error,
        successMessage,
        setSuccessMessage,
        resolvingId,
        setResolvingId,
        showExportModal,
        setShowExportModal,
        roadblocks,
        dfnOptions,
        fetchRoadblocks,
    };
}
